import Vue from 'vue'
import App from './App.vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCarBattery, faSeedling, faStroopwafel, faBrain, faStopwatch, faChartLine, faCode, faUserCheck, faSearchDollar, faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { VBPopover } from 'bootstrap-vue/es/directives'

import { BLink } from 'bootstrap-vue'
Vue.component('b-link', BLink)

import VueRouter from 'vue-router'
// Note: Vue automatically prefixes the directive name with 'v-'
Vue.directive('b-popover', VBPopover)

library.add(faCarBattery, faSeedling, faStroopwafel, faStar, faStarHalfAlt, faBrain, faStopwatch, faChartLine, faCode, faUserCheck, faSearchDollar)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import SplashPage from './components/SplashPage'
import TimeCard from './components/TimeCard'
import ReviewPage from './components/ReviewPage'
import AboutPage from './components/AboutPage'
import GlossaryPage from './components/GlossaryPage'
import FullTextPage from './components/FullTextPage'
import VideoPage from './components/VideoPage'
import HappinessPage from './components/HappinessPage'
import XpplPage from './components/XpplPage'
import TabPage from './components/TabPage'
import ZineMachinesPage from './components/ZineMachinesPage'
import UnpackingPage from './components/UnpackingPage'
import UpsettingPage from './components/UpsettingPage'
import CataloguePage from './components/CataloguePage'
import OverunderPage from './components/OverunderPage'
import XenoPage from './components/XenoPage'
import BedchairtablePage from './components/BedchairtablePage'
import CodeartPage from './components/CodeartPage'
import FemToolsPage from './components/FemToolsPage'
import Magiun from './components/Magiun'
import FSTPage from './components/FSTPage'
import SurveillancePage from './components/SurveillancePage'
import ANNPage from './components/ANNPage'
import Magiun2 from './components/Magiun2'
import RORPage from './components/RORPage'
import RelearnPage from './components/RelearnPage'
import ReadingFoodPage from './components/ReadingFoodPage'
import Magiun3 from './components/Magiun3'
import AmroTimes from './components/AmroTimes'
import ATNOFSPage from './components/ATNOFSPage'
import WellsPage from './components/WellsPage'
import RosaPage from './components/RosaPage'
import FizzClub from './components/FizzClub'
import ATNOFSPub from './components/ATNOFSPub'
import VariaAfhaal from './components/VariaAfhaal'
import MagiunWeb from './components/MagiunWeb'
import Spreads from './components/Spreads'
import SelfMedicated from './components/SelfMedicated'
import Anarchive from './components/Anarchive'
import Writing from './components/Writing'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: SplashPage },
    { path: '/review', component: ReviewPage },
    { path: '/about', component: AboutPage },
    { path: '/glossary', component: GlossaryPage },
    { path: '/fulltext', component: FullTextPage },
    { path: '/video', component: VideoPage },
    { path: '/TimeCard', component: TimeCard },
    { path: '/HappinessPage', component: HappinessPage },
    { path: '/xppl', component: XpplPage },
    { path: '/tab', component: TabPage },
    { path: '/zinemachines', component: ZineMachinesPage },
    { path: '/unpacking', component: UnpackingPage },
    { path: '/upsetting', component: UpsettingPage },
    { path: '/catalogue', component: CataloguePage },
    { path: '/overunder', component: OverunderPage },
    { path: '/xeno', component: XenoPage },
    { path: '/bedchairtable', component: BedchairtablePage },
    { path: '/codeart', component: CodeartPage },
    { path: '/femtools', component: FemToolsPage },
    { path: '/magiun', component: Magiun },
    { path: '/fst', component: FSTPage },
    { path: '/surveillance', component: SurveillancePage },
    { path: '/ann', component: ANNPage },
    { path: '/magiun2', component: Magiun2 },
    { path: '/ror', component: RORPage },
    { path: '/relearn', component: RelearnPage },
    { path: '/readingfood', component: ReadingFoodPage },
    { path: '/magiun3', component: Magiun3 },
    { path: '/amrotimes', component: AmroTimes },
    { path: '/atnofs', component: ATNOFSPage },
    { path: '/wells', component: WellsPage },
    { path: '/rosa', component: RosaPage },
    { path: '/fizz', component: FizzClub },
    { path: '/atnofspub', component: ATNOFSPub },
    { path: '/afhaal', component: VariaAfhaal },
    { path: '/magiunweb', component: MagiunWeb },
    { path: '/spreads', component: Spreads },
    { path: '/selfmedicated', component: SelfMedicated },
    { path: '/anarchive', component: Anarchive },
    { path: '/writing', component: Writing }



  ]

})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
